export default __webpack_public_path__ + "static/media/avatar-normal-geometric-14.f165e172.svg";